module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Key-97b60b88ef59ae3c844748eaf512be270e3319eaf7bad336390d850322547262.svg";